import { action, observable, runInAction } from 'mobx'

export default class FeedView {
  rootStore = null

  @observable accessor isInitializing = false
  @observable accessor isInitialized = false

  constructor(rootStore) {
    this.rootStore = rootStore
  }

  init = async () => {
    if (this.isInitializing) return

    runInAction(() => {
      this.isInitializing = true
    })

    await this.#loadData()

    runInAction(() => {
      this.isInitializing = false
      this.isInitialized = true
    })

    this.analytics.dashboard()?.then()
  }

  get analytics() {
    return this.rootStore.analyticsStore
  }

  @action
  reset = () => {
    this.isInitializing = false
    this.isInitialized = false
    this.posts.reset()
  }

  get posts() {
    return this.rootStore.repositories.postsRepository
  }

  #loadData = async () => {
    if (!this.isInitialized && !this.isInitializing) return

    this.posts.initFeed()
  }
}
